import { render, staticRenderFns } from "./IbanForm.vue?vue&type=template&id=93cf38ce"
import script from "./IbanForm.vue?vue&type=script&lang=ts"
export * from "./IbanForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports